<grange-actions></grange-actions>
<h2>{{ (context | async).title }}</h2>
<p>{{ (context | async).description }}</p>